import { Helmet } from "@dr.pogodin/react-helmet";

export function BaseSEO() {
    return (
        <Helmet>
            <meta charSet="utf-8"/>
            <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
            <meta name="theme-color" content="#000000"/>
            <meta name="description"
                  content="Unique 2D art for Slots development. Experienced team creating high-quality visuals for your projects."/>
            <meta name="keywords" content="2D art, slot development, game art, custom graphics, Lesia K"/>
            <meta name="author" content="Lesia K"/>
            <link rel="icon" href="https://lesia-k.com/assets/Pictures/Fish.png"/>
            <link rel="apple-touch-icon" href="https://lesia-k.com/assets/Pictures/Fish.png"/>
            <link rel="canonical" href="https://lesia-k.com"/>

            <meta property="og:type" content="website"/>
            <meta property="og:url" content="https://lesia-k.com"/>
            <meta property="og:title" content="Slot 2D Art Development"/>
            <meta property="og:description"
                  content="Unique 2D art for Slots development. Experienced team creating high-quality visuals for your projects."/>
            <meta property="og:image" content="https://lesia-k.com/assets/Pictures/Fish.png"/>
            <meta property="og:image:width" content="1200"/>
            <meta property="og:image:height" content="630"/>
            <meta property="og:image:alt" content="Slot 2D Art Development"/>
            <meta property="og:image:type" content="image/png"/>
            <meta property="og:image:secure_url" content="https://lesia-k.com/assets/Pictures/Fish.png"/>
            <meta property="og:locale" content="en_US"/>
            <meta property="og:site_name" content="Lesia K"/>

            <meta name="twitter:card" content="summary_large_image"/>
            <meta name="twitter:url" content="https://lesia-k.com"/>
            <meta name="twitter:title" content="Slot 2D Art Development"/>
            <meta name="twitter:description"
                  content="Unique 2D art for Slots development. Experienced team creating high-quality visuals for your projects."/>
            <meta name="twitter:image" content="https://lesia-k.com/assets/Pictures/Fish.png"/>

        </Helmet>
    );
}
